import React, {useState} from "react";
import {useHistory } from "react-router-dom";
import './LogoutPhone.css';

export default  function LogoutPhone() {
    const [English, setEnglish] = useState(true);
    const history = useHistory();

    const handleLogout =()=>{
        const path= `/`; 
        history.push(path);
    }

    const ChangeToChinese =()=>{
        setEnglish(false);
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
    }

    return (
        <div> 
            {English?(
                <>
                <div className="LogoutPhone">
                <h1> Logout Page</h1>
                <div className="LogoutPhone-Language" onClick={ChangeToChinese}> <h3>中文</h3></div>
                
                <div className="LogoutPhone-box">
                    <p>Click the button to log out !</p>
                    <button onClick={handleLogout}><h6>Logout</h6> </button><br/>
                </div>
                </div>
                </>
            ):(
                <>
                <div className="LogoutPhone">
                <h1> 退出页面</h1>
                <div className="LogoutPhone-Language" onClick={ChangeToEnglish}> <h3>English</h3></div>
                
                <div className="LogoutPhone-box">
                    <p>点击按钮进行登出 !</p>
                    <button onClick={handleLogout}><h6>退出</h6> </button><br/>
                </div>
                </div>
                </>
            )}
        </div>  
    );
}
